import { FlowPage } from 'src/lib/flow/FlowPage';
import { FlowQuestion } from 'src/lib/flow/FlowQuestion';

const radioReferralSourcePage: FlowPage = {
  slug: () => 'radio-referral-source',
  isEnabled: ({ answers }) => {
    return answers['seller.referral_source'] === 'radio';
  },
  title: () => 'Which radio source?',
  autoAdvance: () => true,
  questions: (): FlowQuestion[] => {
    return [
      {
        key: 'seller.referral_source_radio',
        type: 'radio_single_select',
        options: [
          {
            label: 'Radio Ad',
            value: 'radio_ad',
          },
          {
            label: 'DJ Personality',
            value: 'radio_personality',
          },
          {
            label: 'Podcast',
            value: 'podcast',
          },
          {
            label: 'Spotify',
            value: 'spotify',
          },
          {
            label: 'Pandora',
            value: 'pandora',
          },
        ],
      },
    ];
  },
};

export default radioReferralSourcePage;
